import App from 'app/app.js';

function UpsellMessageCtrl($scope, $rootScope) {
  this.bannerVisible = $rootScope.bannerVisible;
  this.addonAdded = $rootScope.addonAdded;
  this.upsellCustomize = $rootScope.upsellCustomize;
  this.showHolidayBanner = $rootScope.showHolidayBanner;
  this.isHolidayBannerShown = true;
  this.hide = function () {
    this.bannerVisible = false;
    $scope.hideClicked();
  };
  this.hideHolidayBanner = function () {
    this.isHolidayBannerShown = false;
  };
}

App.controller('UpsellMessageCtrl', ['$scope', '$rootScope', UpsellMessageCtrl]);
